export const INIT_NOTIFICATION_LIST_REQUEST = 'INIT_NOTIFICATION_LIST_REQUEST';
export const SET_NOTIFICATION_LIST = 'SET_NOTIFICATION_LIST';
export const APPEND_NOTIFICATION_LIST = 'APPEND_NOTIFICATION_LIST';
export const ERROR_NOTIFICATION_LIST = 'ERROR_NOTIFICATION_LIST';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const ERROR_NOTIFICATION_REQUEST = 'ERROR_NOTIFICATION_REQUEST';

export function initNotificationListRequest() {
  return { type: INIT_NOTIFICATION_LIST_REQUEST };
}

export function setNotificationList(data) {
  return { type: SET_NOTIFICATION_LIST, payload: data };
}

export function appendNotificationList(data) {
  return { type: APPEND_NOTIFICATION_LIST, payload: data };
}

export function errorNotificationList(error) {
  return { type: ERROR_NOTIFICATION_LIST, payload: error };
}

export function deleteNotification(notificationId) {
  return { type: DELETE_NOTIFICATION, payload: notificationId };
}

export function errorNotificationRequest(error) {
  return { type: ERROR_NOTIFICATION_REQUEST, payload: error };
}
